import React from 'react'
import { Embed } from 'semantic-ui-react'

function SingleVideo({ src }) {
  return (
    <Embed
      // icon="right circle arrow"
      // placeholder='/assets/images/image-16by9.png'
      url={src}
    />
  )
}

export default SingleVideo



// WEBPACK FOOTER //
// ./src/views/components/SingleVideo.js